import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { Router } from '@angular/router';
import { RequestService } from '@services/https/request.service';
import { LocalStorage } from '@services/local-storage/local-storage';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { LOGOUT } from 'environments/api.path';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [MatMenuModule, CommonModule],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header {
  userInfo: any;
  roleId: any;
  roleName: any;
  name: string = '';
  trainingCompleted: boolean = false;
  isNoTrainingAssigned: boolean = true;
  profileIcon: string = './images/header-icons/profileIcon.svg';
  constructor(
    private readonly _localStorageService: LocalStorage,
    private readonly router: Router,
    private _snackbar: SnackbarService,
    private readonly _request: RequestService
  ) {
    this.userInfo = JSON.parse(this._localStorageService.getUser());
    this.roleId = this.userInfo.role[0].roleId;
    this.roleName = this.userInfo.role[0].roleName;
    this.name = `${this.userInfo.firstName} ${this.userInfo.lastName}`;
    this.getTrainingStatus();
  }

  logout() {
    let requestData: any = {};
    this._request.POST(`${LOGOUT}`, requestData).subscribe({
      next: (res: any) => {
        this.router.navigate(['auth/login']);
        this._localStorageService.clearAllData();
        this._snackbar.notify(res.message, 1);
      },
      error: (err: any) => {
        this._snackbar.notify(err.message, 2);
      },
    });
  }

  moveToTraining() {
    this.router.navigate(['training/training-center']);
  }

  getTrainingStatus() {
    this._request.GET(`check-training-status`, {}).subscribe({
      next: (resp: any) => {
        this.trainingCompleted = resp?.data?.isComplete || false;
        this.isNoTrainingAssigned = resp?.data?.isNoTrainingAssigned || true;
      },
      error: (err: any) => {
        this._snackbar.notify(err.message, 2);
      },
    });
  }
}
